import { translation, } from '@tymia/main-api';
import { useConfig, } from './ConfigContext.js';
export function useTranslation() {
    const config = useConfig();
    return translation(config.getLanguage());
}
//# sourceMappingURL=useTranslation.js.map